<template>
  <social-proof class="usa" :class="{ desktop: $isDesktop }">
    <template #press>
      <div class="press">
        <img
          src="@/assets/homepage/press/vogue.svg"
          loading="lazy"
          alt="Vogue"
          width="125"
          height="33"
        />
        <img
          src="@/assets/homepage/press/washington-post.svg"
          loading="lazy"
          alt="Washington Post"
          width="198"
          height="31"
        />
        <img
          src="@/assets/homepage/press/usa-today.svg"
          loading="lazy"
          alt="USA Today"
          width="205"
          height="31"
        />
        <template v-if="$isDesktop">
          <img
            src="@/assets/homepage/press/forbes.svg"
            loading="lazy"
            alt="Forbes"
            width="125"
            height="34"
          />
          <img
            src="@/assets/homepage/press/fox-news.svg"
            loading="lazy"
            alt="Fox News"
            width="40"
            height="40"
          />
          <img
            src="@/assets/homepage/press/people-magazine.svg"
            loading="lazy"
            alt="People Magazine"
            width="97"
            height="40"
          />
        </template>
      </div>
    </template>
  </social-proof>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'
import SocialProof from './SocialProof.vue'

@Component({
  mixins: [SocialProof],
})
class SocialProofUsa extends Vue {}

export default toNative(SocialProofUsa)
</script>
<style scoped>
.usa:not(.desktop) .press {
  grid-template-columns: auto;
  grid-template-rows: auto auto auto;
  column-gap: 0;
  row-gap: 0.3em;
}

.usa:not(.desktop) .press img {
  max-height: 1.2em;
  max-width: 6em;
}

.usa .press img:first-of-type {
  grid-row: unset;
  grid-column: unset;
  margin: 0;
}

/* mobile landscape */
@media screen and (min-width: 320px) and (max-width: 998px) and (orientation: landscape) {
  .usa:not(.desktop) .press {
    grid-template-columns: repeat(3, auto);
    grid-template-rows: auto;
    column-gap: 0.75em;
  }

  .usa:not(.desktop) .press img:first-of-type {
    grid-row: unset;
    grid-column: unset;
  }
}
</style>
